var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 2,
    fill: "#22C55E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.16 5.33325H11.564C10.388 5.33325 9.456 5.33325 8.72733 5.43192C7.97667 5.53325 7.36933 5.74659 6.89067 6.22725C6.41133 6.70792 6.19867 7.31792 6.098 8.07125C6 8.80325 6 9.73858 6 10.9193V14.8113C6 15.8166 6.61333 16.6779 7.48467 17.0393C7.44 16.4326 7.44 15.5826 7.44 14.8746V11.5346C7.44 10.6806 7.44 9.94392 7.51867 9.35459C7.60333 8.72259 7.794 8.11725 8.28333 7.62592C8.77267 7.13459 9.376 6.94325 10.0053 6.85792C10.592 6.77925 11.3253 6.77925 12.1767 6.77925H14.2233C15.074 6.77925 15.806 6.77925 16.3933 6.85792C16.2173 6.40883 15.9101 6.02318 15.5118 5.75122C15.1134 5.47927 14.6423 5.33361 14.16 5.33325Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3999 11.598C8.3999 9.78068 8.3999 8.87201 8.96257 8.30734C9.52457 7.74268 10.4292 7.74268 12.2399 7.74268H14.1599C15.9699 7.74268 16.8752 7.74268 17.4379 8.30734C17.9999 8.87201 17.9999 9.78068 17.9999 11.598V14.8113C17.9999 16.6287 17.9999 17.5373 17.4379 18.102C16.8752 18.6667 15.9699 18.6667 14.1599 18.6667H12.2399C10.4299 18.6667 9.52457 18.6667 8.96257 18.102C8.3999 17.5373 8.3999 16.6287 8.3999 14.8113V11.598Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.4dca659ff6ba622fb369fe409df9762b.svg";
export { ForwardRef as ReactComponent };